/**
 * OrbDocReferenceOperatorsValidateENDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocReferenceOperatorsValidateENDocScreen
 */

import { useOrbDocReferenceOperatorsValidateENDocScreenLogic } from '@/hooks/traits/useOrbDocReferenceOperatorsValidateENDocScreenLogic';
import type { OrbDocReferenceOperatorsValidateENDocScreenConfig } from '@/hooks/traits/useOrbDocReferenceOperatorsValidateENDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocReferenceOperatorsValidateENDocView as OrbDocReferenceOperatorsValidateENDocViewEntity } from '@app/shared';
import { OrbDocReferenceOperatorsValidateENDocBodyView } from '@/components/traits/OrbDocReferenceOperatorsValidateENDocBodyView';
import { OrbDocReferenceOperatorsValidateENDocFooterView } from '@/components/traits/OrbDocReferenceOperatorsValidateENDocFooterView';
import { OrbDocReferenceOperatorsValidateENDocHeaderView } from '@/components/traits/OrbDocReferenceOperatorsValidateENDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocReferenceOperatorsValidateENDocScreenViewProps {
  config?: Partial<OrbDocReferenceOperatorsValidateENDocScreenConfig>;
}

export function OrbDocReferenceOperatorsValidateENDocScreenView({ config: propsConfig }: OrbDocReferenceOperatorsValidateENDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocReferenceOperatorsValidateENDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocReferenceOperatorsValidateENDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocReferenceOperatorsValidateEN" trait="OrbDocReferenceOperatorsValidateENDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocReferenceOperatorsValidateENDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocReferenceOperatorsValidateENDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocReferenceOperatorsValidateENDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocReferenceOperatorsValidateENDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocReferenceOperatorsValidateENDocScreenView;
